function openModal() {
  const modal = document.getElementById("aofl-modal");
  if (modal) modal.style.display = "flex";
}

function closeModal() {
  const modal = document.getElementById("aofl-modal");
  if (modal) modal.style.display = "none";
}

function triggerBodyScrollLock(lockType: "on" | "off" = "off") {
  const modal = document.getElementById("aofl-modal");
  if (!modal) return;

  if (lockType === "on") {
    document.body.style.overflow = "hidden";
    modal.style.overflow = "auto";
  } else {
    document.body.style.overflow = "auto";
    modal.style.overflow = "hidden";
  }
}

function setCookie(name: string, value: string | boolean, days?: number) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

function closeModalOnQualifyingKeys(e: KeyboardEvent) {
  if (e.key === "Escape") {
    closeModalMode();
  }
}

function openModalMode() {
  document.addEventListener("keyup", closeModalOnQualifyingKeys);
  triggerBodyScrollLock("on");
  openModal();
}

function closeModalMode() {
  document.removeEventListener("keyup", closeModalOnQualifyingKeys);
  triggerBodyScrollLock("off");
  closeModal();
}

function setPrivacyCookieAndCloseModal() {
  setCookie("TARGETING_COOKIES", true);
  setCookie("ANALYTICS_PERFORMANCE_COOKIES", true);
  closeModalMode();
}

export function initModal() {
  const modal = document.getElementById("aofl-modal");
  if (!modal) return;

  modal.style.display = "none";

  const trigger =
    document.getElementById("do-not-sell-my-information") ||
    document.getElementById("footer-dnsmi-link") ||
    document.querySelector('a[href="#do-not-sell-my-information"]') ||
    document.querySelector('a[href="#footer-dnsmi-link"]');

  if (trigger) {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      openModalMode();
    });
  }

  document
    .getElementById("aofl-modal-close-btn")
    ?.addEventListener("click", closeModalMode);

  document
    .getElementById("aofl-footer-dnsmi-btn")
    ?.addEventListener("click", setPrivacyCookieAndCloseModal);
}
